export default "__VITE_ASSET__BIx5wbyf__"